import { isEnterprise } from "../constants/edition";
import { BASE_DOMAIN } from "./brandHost";

/**
 * Does a PLATFORM-billed payment have to leave this page to be paid?
 *
 * Subscriptions, service invoices, extra storage and marketplace packs are paid
 * to the platform's Razorpay account, and Razorpay refuses a checkout opened
 * from a website that account has not registered. `*.lmscampus.com` is
 * registered; an institute's custom domain (`lms.abc.com`) is not, and the
 * payment fails inside the Razorpay window with nothing the customer can do.
 * On such a host the payment opens in a new tab on the platform's own domain
 * instead (`useHostedCheckout`, backed by vc_be's hostedCheckoutController).
 *
 * Not for an institute's OWN Razorpay keys (student fees) — those are the
 * institute's account and the institute registers its own domain on it.
 *
 * Enterprise builds run on their own domain against their own Razorpay
 * account, so they never need it. Local dev never needs it either (test-mode
 * keys do not check the website); set `localStorage["vc-hosted-checkout"] = "1"`
 * to exercise the hosted flow anyway.
 */
export const HOSTED_CHECKOUT_FORCE_KEY = "vc-hosted-checkout";

const PLATFORM_DOMAIN = BASE_DOMAIN;
const IPV4 = /^\d{1,3}(\.\d{1,3}){3}$/;

export function needsHostedCheckout(hostname = window.location.hostname) {
  try {
    if (window.localStorage.getItem(HOSTED_CHECKOUT_FORCE_KEY) === "1") return true;
  } catch {
    // Storage blocked — decide from the host alone.
  }
  if (isEnterprise) return false;
  const host = String(hostname || "").toLowerCase();
  if (!host || host === "localhost" || host.endsWith(".localhost") || IPV4.test(host)) return false;
  return !(host === PLATFORM_DOMAIN || host.endsWith(`.${PLATFORM_DOMAIN}`));
}
